import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { FamilyBenefitsComponent } from './family-benefits.component';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import * as  _ from 'lodash';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { Subscription } from 'rxjs';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../../_infrastructure/Utils/UtilsService';

@Component({
    selector: 'family-benefits-table-edit',
    templateUrl: './family-benefits-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class FamilyBenefitsTableEditComponent extends TableEditBase<models.FamilyBenefitEntryVM> implements OnInit, OnDestroy {
  @ViewChild('workAbroadItemEdit') editForm;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.benefitTypes)
  public benefitTypes: models.DimensionVM[];
  @CommonData(DomainCodes.subBenefitTypes)
  public subBenefitTypes: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.martialStatus)
  public maritalStatuses: models.DimensionVM[];

  public minDate = new Date(1900, 0, 1);
  public maxDate = new Date();

  private mainSubscription: Subscription = new Subscription(); 
  constructor(@Inject(FamilyBenefitsComponent) parent: Component, private modalService: ModalService,
    private commonDataService: CommonDataService, private utilsService: UtilsService) {
    super(parent, modalService);
    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.benefitTypes,
      DomainCodes.subBenefitTypes,
      DomainCodes.yesNo,
      DomainCodes.country,
      DomainCodes.genders,
      DomainCodes.identificationType,
      DomainCodes.martialStatus,
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.benefitTypes = this.utilsService.getDomainOfDomains(DomainCodes.benefitTypes, results).dimensions;
        this.subBenefitTypes = this.utilsService.getDomainOfDomains(DomainCodes.subBenefitTypes, results).dimensions;
        this.yesNo = this.utilsService.getDomainOfDomains(DomainCodes.yesNo, results).dimensions;
        this.nationalities = this.utilsService.getDomainOfDomains(DomainCodes.country, results).dimensions;
        this.genders = this.utilsService.getDomainOfDomains(DomainCodes.genders, results).dimensions;
        this.documentTypes = this.utilsService.getDomainOfDomains(DomainCodes.identificationType, results).dimensions;
        this.maritalStatuses = this.utilsService.getDomainOfDomains(DomainCodes.martialStatus, results).dimensions;
      })
    );

  }

  ngOnInit(): void {
    super.ngOnInit();
    //TODO make this pretieer
    if (isNullOrUndefined(this.item.benefitTypes) || ((typeof this.item.benefitTypes) == "string" && this.item.benefitTypes?.toString()?.trim() == ""))
      this.item.benefitTypes = <models.BenefitTypes>{};
    if (isNullOrUndefined(this.item.subBenefitTypes) || ((typeof this.item.subBenefitTypes) == "string"  && this.item.subBenefitTypes?.toString()?.trim() == ""))
      this.item.subBenefitTypes = <models.SubBenefitTypes>{};

    if (isNullOrUndefined(this.item.benefitTypes.benefitTypesList))
      this.item.benefitTypes.benefitTypesList = [];
    if (isNullOrUndefined(this.item.subBenefitTypes.subBenefitTypesList))
      this.item.subBenefitTypes.subBenefitTypesList = [];


  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  checkBoxChanged(event: any, code: string, targetList: string[]): void {
    if (event.target.checked)
      targetList.push(code);
    else {
      _.remove(targetList, x => x === code);
    } 
  }
  cleanSubTypes(event: any , code: string): void {
    if (!event.target.checked && code === '16')
      this.item.subBenefitTypes.subBenefitTypesList = [];
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.item.dateOfBirth).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }
}
